import clsx from 'clsx';

export type PageTitleProps = {
  className?: string;
  title: string;
  subtitle: string;
};

export const PageTitle = ({ className = '', title, subtitle }: PageTitleProps) => {
  return (
    <div className={clsx(className, 'space-y-3')}>
      <p className={clsx('text-2xl md:text-3xl lg:text-4xl text-center')}>{title}</p>
      <p className={clsx('text-sm md:text-md  text-opacity-50 uppercase text-center')}>
        {subtitle}
      </p>
      {/* <p className={clsx('text-sm /50')}>{subtitle}</p> */}
    </div>
  );
};
